import { PlayersClient, baseUrl } from '../../api';
import { BaseActionReducer } from '../baseActionReducer';
export const playersActionReducer = new BaseActionReducer({ keyStart: 'PLAYERS', payloadName: 'players' });
const syncPlayersActions = playersActionReducer.buildSyncActions();
const playersClient = new PlayersClient(null, baseUrl);
const asyncPlayersActionCreators = {
    searchPlayers: (name, clubName, playerId, gender, ageGroupId, matchDate) => {
        return playersActionReducer.createAsyncAction(playersClient.search(name, clubName, playerId, gender, ageGroupId, matchDate));
    }
};
export const playersActions = Object.assign(Object.assign({}, syncPlayersActions), asyncPlayersActionCreators);
